export default __webpack_public_path__ + "static/media/money-bag.2e26f5d7.png";